<template>
  <div class="copyright">
    <div class="container">
      <h1>Copyright</h1>
      <p>Any material on this tool may be reproduced provided that:</p>
      <ul>
        <li>the content is not changed</li>
        <li>it is not sold</li>
        <li>the material is not used to promote or endorse any product or service</li>
        <li>it is not used in an inappropriate or misleading context</li>
        <li>
          any disclaimers included on the published information are reproduced on the material
        </li>
        <li>an acknowledgment of the source is included.</li>
      </ul>
      <p>
        Please note, this does not apply to any logos, emblems and trademarks on the tool, the
        tool's design elements, or any photography or imagery. If you wish to reproduce any of
        these, please contact us to discuss:
        <a href="mailto:family_violence_CPP@msd.govt.nz?subject=Service Finder Tool" target="_top">
          family_violence_CPP@msd.govt.nz
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyrightView',
};
</script>
